import { createTheme } from '@mui/material';
import type { ThemeConfig } from 'antd';
import { MuiButton } from './default/components/mui-button';
import { MuiDialog } from './default/components/mui-dialog';
import { MuiDialogActions } from './default/components/mui-dialog-actions';
import { MuiDialogContent } from './default/components/mui-dialog-content';
import { MuiDialogContentText } from './default/components/mui-dialog-content-text';
import { MuiDialogTitle } from './default/components/mui-dialog-title';
import { MuiMenu } from './default/components/mui-menu';
import { MuiPaper } from './default/components/mui-paper';
import { MuiSwitch } from './default/components/mui-switch';
import { MuiTooltip } from './default/components/mui-tooltip';
import { palette } from './default/palette';

export const defaultTheme: ThemeConfig = {
  token: {
    fontFamily: 'Inter, sans-serif',
  },
};

export const muiDefaultTheme = createTheme({
  typography: {
    fontFamily: 'Inter, sans-serif',
  },
  palette,
  components: {
    MuiMenu,
    MuiButton,
    MuiDialog,
    MuiDialogTitle,
    MuiDialogContent,
    MuiDialogActions,
    MuiDialogContentText,
    MuiPaper,
    MuiSwitch,
    MuiTooltip,
  },
});